module.exports = __webpack_public_path__ + "static/img/top.8ceeb40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobel/top.png
// module id = rJo7
// module chunks = 1